import { Reducer } from "react";
import { State } from "./types";

export const ACTIONS = {
  STORE_RESET: "STORE_RESET",
  DATA_REQUESTED: "DATA_REQUESTED",
  FETCH_MP_SUCCESS: "FETCH_MP_SUCCESS",
  FETCH_MP_ERROR: "FETCH_MP_ERROR",
  FETCH_MP_EMAIL_SUCCESS: "FETCH_MP_EMAIL_SUCCESS",
  FETCH_MP_EMAIL_ERROR: "FETCH_MP_EMAIL_ERROR",
  UPDATE_FORM_VALUES: "UPDATE_FORM_VALUES",
  SET_SENDING_EMAIL: "SET_SENDING_EMAIL",
};

export const initialState: State = {
  status: "STORE_OK",
  loading: false,
  error: "",
  formStep: 0,
  postcode: "",
  mp: {
    name: "",
    party: "",
    constituency: "",
    email: "",
    thumbnail: "",
  },
  formValues: {
    firstName: "",
    surname: "",
    email: "",
    address: "",
    postcode: "",
    subject: "",
    message: "",
    optIn: "yes",
    drivesEV: "",
    evDuration: "",
    evExperience: "",
    consideringEV: "",
    concerns: [],
  },
  sendingEmail: false,
};

const initializer = (initialState: State) => initialState;

export const reducer: Reducer<State, any> = (
  state: State,
  { type, payload }: any
): State => {
  switch (type) {
    case ACTIONS.STORE_RESET:
      return initializer(payload);
    case ACTIONS.DATA_REQUESTED:
      return {
        ...state,
        status: ACTIONS.DATA_REQUESTED,
        loading: true,
        postcode: payload,
      };
    case ACTIONS.FETCH_MP_SUCCESS:
      return { ...state, loading: false, mp: payload };
    case ACTIONS.FETCH_MP_ERROR:
      return { ...state, loading: false, error: payload.error };
    case ACTIONS.FETCH_MP_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        mp: { ...state.mp, email: payload },
      };
    case ACTIONS.FETCH_MP_EMAIL_ERROR:
      return { ...state, loading: false, error: payload.erro };
    case ACTIONS.UPDATE_FORM_VALUES:
      return { ...state, formValues: { ...state.formValues, ...payload } };
    case ACTIONS.SET_SENDING_EMAIL:
      return { ...state, sendingEmail: payload };
    default:
      return state;
  }
};
